import React from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

type NotificationFilter = 'all' | 'new'

interface Props {
  onFilter: (value: NotificationFilter) => void
  value: NotificationFilter
}

export const NotificationFeedFilter: React.FC<Props> = ({ value, onFilter }) => {
  const [t] = useTranslation()

  return (
    <SwitchContainer>
      <SwitchPill $active={value === 'new'} />
      <SwitchButton type="button" $active={value === 'new'} onClick={() => onFilter('new')}>
        {t('notificationFeed.filter.new')}
      </SwitchButton>
      <SwitchButton type="button" $active={value === 'all'} onClick={() => onFilter('all')}>
        {t('notificationFeed.filter.all')}
      </SwitchButton>
    </SwitchContainer>
  )
}

const SwitchContainer = styled.div`
  display: flex;
  background: ${({ theme }) => theme.colors.neutralGray};
  border-radius: 9999px;
  padding: ${({ theme }) => theme.spacing.xxxs}rem;
  position: relative;
  width: 130px;
  border: 1px solid rgba(0, 0, 0, 0.02);
  align-items: center;
`

const SwitchButton = styled.button<{ $active: boolean }>`
  position: relative;
  z-index: 2;
  flex: 1;
  background: none;
  border: none;
  outline: none !important;
  font-size: ${({ theme }) => theme.fontSize.xs}rem;
  font-weight: ${({ $active }) => ($active ? '600' : '500')};
  color: ${({ $active, theme }) => ($active ? theme.colors.neutralWhite : theme.colors.metalGray)};
  padding: ${({ theme }) => `${theme.spacing.xs}rem 0`};
  border-radius: 9999px;
  cursor: pointer;
  transition: color 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  text-align: center;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    color: ${({ $active, theme }) =>
      $active ? theme.colors.neutralWhite : theme.colors.neutralBlack};
  }
`

const SwitchPill = styled.div<{ $active: boolean }>`
  position: absolute;
  top: 2px;
  bottom: 2px;
  left: 2px;
  width: calc(50% - 2px);
  background: ${({ theme }) => theme.colors.primary};
  border-radius: 9999px;
  z-index: 1;
  box-shadow: ${({ theme }) => theme.shadow.md};
  transform: ${({ $active }) => ($active ? 'translateX(0)' : 'translateX(100%)')};
  transition: transform 0.22s cubic-bezier(0.4, 0, 0.2, 1);
  height: 24px;
`
